var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_378_788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24.5117C19.1339 24.5117 24.5117 19.1339 24.5117 12.5C24.5117 5.86611 19.1339 0.488281 12.5 0.488281C5.86611 0.488281 0.488281 5.86611 0.488281 12.5C0.488281 19.1339 5.86611 24.5117 12.5 24.5117Z",
    fill: "#6E83B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 22.2656C17.1715 22.2656 20.9587 20.0795 20.9587 17.3828C20.9587 14.6861 17.1715 12.5 12.4999 12.5C7.82817 12.5 4.04102 14.6861 4.04102 17.3828C4.04102 20.0795 7.82817 22.2656 12.4999 22.2656Z",
    fill: "#EDEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5C15.1967 12.5 17.3828 10.3139 17.3828 7.61719C17.3828 4.92048 15.1967 2.73438 12.5 2.73438C9.8033 2.73438 7.61719 4.92048 7.61719 7.61719C7.61719 10.3139 9.8033 12.5 12.5 12.5Z",
    fill: "#EDEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 18.3594L16.4408 13.3282C15.2354 12.7958 13.9021 12.5 12.4997 12.5C11.0973 12.5 9.76401 12.7958 8.55859 13.3282L12.4997 18.3594Z",
    fill: "#D3D3D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_378_788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.83ef0c92afaf084c080773df52c68860.svg";
export { ForwardRef as ReactComponent };